import { ScriptIcon } from './ScriptIcon';

/**
 * author: Michael Irigoyen
 * id 89D63ACC-0EB2-4C0C-BAFF-65846D32B937
 * name script
 * version: 3.0.39
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/script.svg
 * tags
 * - Gaming / RPG 
 */
export const ScrollIcon = ScriptIcon;
export default ScrollIcon